<template>
	<!-- 统计分析 企业安全专项检查 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
			
        	<el-form-item>
				<el-input v-model="filters.coName" placeholder="企业名称"></el-input>
			</el-form-item>

			<el-form-item>
				<el-input v-model="filters.fileNf" placeholder="年份"></el-input>
			</el-form-item>
        
			<el-form-item>
				<el-button type="primary" v-on:click="getSumListPage">查询</el-button>
			</el-form-item>
			
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			
      		<el-table-column prop="coName" label="企业名称"  align="center" min-width="200">
		 	</el-table-column>

       		<el-table-column v-if="showcity"  prop="cityName" label="所属城市" align="center" min-width="100">
			</el-table-column>
       		<el-table-column prop="coHeadName" label="法人姓名" align="center" min-width="100">
			</el-table-column>
			<el-table-column prop="coHeadMobile" label="联系电话" align="center" min-width="130">
			</el-table-column>
			<el-table-column  label="一报告双签字" align="center"  min-width="120">
				<template slot-scope="scope">
					<span>{{scope.row.signAct}}</span><br>
					<span>{{scope.row.signActDesc}}</span>
				</template>
			</el-table-column>

			<el-table-column label="五个一活动" align="center"  min-width="120">
				<template slot-scope="scope">
					<!-- 触发悬浮的元素 -->
					<div class="hover-trigger" @mouseover="showTooltip(scope.row, $event)" @mouseout="hideTooltip()">
						<span>{{scope.row.fiveAct}}</span>
					</div>
					  <!-- 浮动层（条件渲染） -->
					<div v-if="visibleTooltip" class="custom-tooltip" :style="{ left: tooltipLeft + 'px', top: tooltipTop + 'px' }" >
						<h4>缺少的报告清单</h4>
					<span class="wrap-span">{{currentRow.fiveActDesc}}</span>
					</div>
					
				</template>
			</el-table-column>

			<el-table-column label="企业主要负责人达标情况" align="center">
				
				<el-table-column  label="年度六类报告" align="center"  min-width="80">
					<template slot-scope="scope">
						<!-- 触发悬浮的元素 -->
						<div class="hover-trigger" @mouseover="showTooltip2(scope.row, $event)" @mouseout="hideTooltip2()">
							<span>{{scope.row.yearAct}}</span>
						</div>
						<!-- 浮动层（条件渲染） -->
						<div v-if="visibleTooltip2" class="custom-tooltip" :style="{ left: tooltipLeft2 + 'px', top: tooltipTop2 + 'px' }" >
							<h4>缺少的报告清单</h4>
						<span class="wrap-span">{{currentRow2.yearActDesc}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="lessonAct" label="半年度辅导课报告" align="center"  min-width="100">
				</el-table-column>
				<el-table-column prop="searchAct" label="季度研究报告" align="center"  min-width="80">
				</el-table-column>
				<el-table-column prop="monthCheck" label="月度检查报告" align="center"  min-width="80">
				</el-table-column>
				<el-table-column prop="talkCheck" label="月度讲评会报告" align="center"  min-width="100">
				</el-table-column>
			</el-table-column>
     
			<!-- <el-table-column label="操作" align="center" width="300">
				<template slot-scope="scope">
					<el-button  type="primary" size="small" @click="handleRecordDetail(scope.$index, scope.row)">排查统计</el-button>
					<el-button  type="warning" size="small" @click="handleReportDetail(scope.$index, scope.row)">上报统计</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>


		 <!--明细界面-->
		 <el-dialog :title="detailFormTitle"  v-model="detailFormVisible" :close-on-click-modal="false">

			<el-row>
				<el-col >
				<div >
					<label>企业名称:  {{detailForm.companyName}}</label>
				</div>
				</el-col>
			</el-row>
			

	  	<el-table :data="feedata" highlight-current-row v-loading="feelistLoading">
			<el-table-column prop="createTime" label="月份" align="center"  min-width="150">
			</el-table-column>
			<el-table-column prop="mcount" label="记录数量" align="center"  min-width="120">
			</el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total,prev, pager, next" @current-change="handletypeChange"
          :page-size="5" :total="feetotal" style="float:right;"
        ></el-pagination>
      </el-col>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="detailFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
		
	</section>
</template>

<script>
	import {safefilecheckSumPage,reportMonthPage,recordMonthPage} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id
				showcity:true, //是否显示所属城市

				filters: {
					coName:"",
					fileNf:''
				},
				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//明细
				detailFormVisible: false,
				detailFormTitle:'',  //对话框名称
				detailForm: {
					companyName: "",
				},
				qType:"0", //0记录统计1上报统计
				qcoId:0, //当前查看的企业id
				feedata: [],
				feetotal: 0,
				feepage: 1,
				feelistLoading: false,
				
				//浮动显示有关
				visibleTooltip: false, // 浮动层显示状态
				currentRow: null, // 当前悬停行数据
				tooltipLeft: 0, // 浮动层左坐标
				tooltipTop: 0, // 浮动层上坐标

				visibleTooltip2: false, // 浮动层显示状态
				currentRow2: null, // 当前悬停行数据
				tooltipLeft2: 0, // 浮动层左坐标
				tooltipTop2: 0 // 浮动层上坐标
				//end
			}
		},
		methods: {
			// 显示浮动层
			showTooltip(row, e) {
			this.currentRow = row
			this.visibleTooltip = true
			// 计算浮动层位置（基于鼠标位置偏移，避免遮挡）
			this.tooltipLeft = e.pageX + 10
			this.tooltipTop = e.pageY + 10
			},

			// 隐藏浮动层
			hideTooltip() {
			this.visibleTooltip = false
			this.currentRow = null
			},
			showTooltip2(row, e) {
			this.currentRow2 = row
			this.visibleTooltip2 = true
			// 计算浮动层位置（基于鼠标位置偏移，避免遮挡）
			this.tooltipLeft2 = e.pageX + 10
			this.tooltipTop2 = e.pageY + 10
			},

			// 隐藏浮动层
			hideTooltip2() {
			this.visibleTooltip2 = false
			this.currentRow2 = null
			},

			handleCurrentChange(val) {				
				this.page = val;
				this.getSumListPage();
			},
			//获取列表
			getSumListPage() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.coName,
					fileNf: this.filters.fileNf
				};

				this.listLoading = true;

				safefilecheckSumPage(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			handleReportDetail: function (index, row) {
				this.detailFormVisible=true
				this.detailFormTitle = "企业重大隐患上报 按月统计"  
				
				this.detailForm.companyName=row.coName
				this.qcoId=row.coId
				this.feepage=1
				this.qType="1"
				this.getReportMonthPage()
			
			},
			
			handleRecordDetail: function (index, row) {
				this.detailFormVisible=true
				this.detailFormTitle = "企业隐患排查记录 按月统计"  

				this.detailForm.companyName=row.coName

				this.qcoId=row.coId
				this.feepage=1
				this.qType="0"
				this.getRecordMonthPage()
			},
			//
			getRecordMonthPage() {
				
				let para = {
					page: this.feepage,
					pageSize:5,
					coId:this.qcoId,
				};

				this.feelistLoading = true;

				recordMonthPage(para).then((res) => {
					if(res.data.code==0){
						this.feetotal = res.data.data.total;
						this.feedata = res.data.data.list;
					}
					
					this.feelistLoading = false;

				});
			},
			getReportMonthPage() {
				
				let para = {
					page: this.feepage,
					pageSize:5,
					coId:this.qcoId,
				};

				this.feelistLoading = true;

				reportMonthPage(para).then((res) => {
					if(res.data.code==0){
						this.feetotal = res.data.data.total;
						this.feedata = res.data.data.list;
					}
					
					this.feelistLoading = false;

				});
			},
			handletypeChange(val) {
				this.feepage = val;

				if (this.qType=="0") {
					this.getRecordMonthPage();
				} else {
					this.getReportMonthPage();
				}
			
			},
			
		
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.showcity=true
			if (user.data.roleId=="3") //城市管理员不显示所属城市
			{
				this.showcity=false
			}

			const currentYear = new Date().getFullYear();
      		this.filters.fileNf=currentYear.toString(); 

			this.getSumListPage();
		}
	}

</script>

<style scoped>
	
/* 触发元素样式 */
.hover-trigger {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}

/* 浮动层样式 */
.custom-tooltip {
  position: fixed; /* 固定定位，避免表格滚动时偏移 */
  z-index: 9999; /* 确保在最上层 */
  width: 220px;
  padding: 12px;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.wrap-span {
  /* 关键样式：识别\n换行，同时压缩多余空格 */
  white-space: pre-line;
  /* 可选：让span支持换行（默认行内元素，内容过长会溢出，转为行内块/块级） */
  display: inline-block; /* 或 block，根据布局需求选择 */
  width: 100%; /* 可选：限制宽度，触发自动换行 */
}

</style>


// WEBPACK FOOTER //
// safefileCheckForm.vue?c8f98bc0